module.exports = __webpack_public_path__ + "static/media/_space_blue.71b1461b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_space_blue.jpg
// module id = 45
// module chunks = 0